import { useEffect, useState } from "react";
import { Toaster } from "@/components/ui/Toast";
import { LoadingSpinner } from "@/components/ui/LoadingSpinner";
import { Routes } from "./routes";
import { bootstrapSession } from "@/lib/session";

export function App() {
  // Prove the HttpOnly cookie session once on load before rendering guarded
  // routes. Until this resolves the auth store's `authed` flag is untrusted.
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    bootstrapSession().finally(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center">
        <LoadingSpinner size={24} />
      </div>
    );
  }

  return (
    <>
      <Routes />
      <Toaster />
    </>
  );
}
